import styled from '@emotion/styled';

export const Msg = styled.h2`
  font-size: 2rem;
  margin-top: 7rem;
  line-height: 1.25;
`;
